import { MapPin, Plane, ArrowUpRight } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { BRAND } from "../lib/content";

export default function Location() {
  const { t } = useI18n();

  return (
    <>
      <section className="pt-16 md:pt-24 pb-16" data-testid="location-hero">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="overline">{t("location.overline")}</div>
            <h1 className="mt-5 text-5xl md:text-7xl leading-[1.02]">
              {t("location.title")}
            </h1>
            <p className="mt-8 text-lg text-[#5C5042] leading-relaxed max-w-2xl">
              {t("location.body")}
            </p>
          </div>

          <AddressCard />
        </div>
      </section>

      <MapEmbed />
    </>
  );
}

function AddressCard() {
  const { t } = useI18n();

  return (
    <div className="md:col-span-5">
      <div className="bg-[#EFEAE1] p-8 space-y-8">
        <div>
          <div className="overline mb-3">{t("location.address_label")}</div>
          <div className="flex items-start gap-3 text-[#2C241B]">
            <MapPin size={18} strokeWidth={1.3} className="mt-1 text-[#6B4A2B]" />
            <div className="text-base leading-relaxed">
              Quartier {BRAND.address.quartier}<br />
              Commune {BRAND.address.commune}<br />
              Arrondissement {BRAND.address.arrondissement}<br />
              {BRAND.address.country}
            </div>
          </div>
          <a
            href={BRAND.googleMaps}
            target="_blank"
            rel="noreferrer"
            data-testid="location-open-maps"
            className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-[#6B4A2B] border-b border-[#6B4A2B]/40 pb-1 hover:border-[#6B4A2B]"
          >
            {t("location.open_maps")} <ArrowUpRight size={14} />
          </a>
        </div>

        <div className="border-t border-[#6B4A2B]/15 pt-8">
          <div className="overline mb-3">{t("location.getting_here")}</div>
          <div className="flex items-start gap-3 text-[#2C241B]">
            <Plane size={18} strokeWidth={1.3} className="mt-1 text-[#6B4A2B]" />
            <p className="text-base leading-relaxed">{t("location.airport")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function MapEmbed() {
  return (
    <section className="pb-24" data-testid="location-map">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative w-full h-[420px] md:h-[560px] border border-[#6B4A2B]/15 overflow-hidden">
          <iframe
            title="Guesthouse Bambou Beach — Grand-Popo, Bénin"
            src="https://www.google.com/maps?q=Grand-Popo,Benin&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
